import { Button } from '@domcrm/embed-ui';

type Props = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function LogoutConfirmDialog({ open, onConfirm, onCancel }: Props) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[110] flex items-center justify-center bg-black/55 p-4"
      role="presentation"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onCancel();
      }}
    >
      <div
        className="w-full max-w-sm rounded-2xl bg-[var(--bg-elevated)] p-5 shadow-lg"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="logout-dialog-title"
        aria-describedby="logout-dialog-desc"
      >
        <h2
          id="logout-dialog-title"
          className="text-lg font-semibold text-[var(--text)]"
        >
          Выход из аккаунта
        </h2>
        <p
          id="logout-dialog-desc"
          className="mt-2 text-sm text-[var(--text-muted)]"
        >
          Вы уверены, что хотите выйти? Для повторного входа потребуется ввести
          логин и пароль.
        </p>
        <div className="mt-5 flex flex-col gap-2 sm:flex-row-reverse sm:justify-start">
          <Button type="button" variant="danger" className="w-full sm:w-auto" onClick={onConfirm}>
            Выйти
          </Button>
          <Button type="button" variant="secondary" className="w-full sm:w-auto" onClick={onCancel}>
            Отмена
          </Button>
        </div>
      </div>
    </div>
  );
}
